import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CreateOrgFeature } from "@/features/onboarding/CreateOrgFeature";
import { OnboardingLayout } from "@/features/onboarding/OnboardingLayout";

const createOrgSearchSchema = z.object({
  redirect: z.string().optional(),
});

function CreateOrgPage() {
  return (
    <OnboardingLayout eyebrow="Get started">
      <CreateOrgFeature embedded />
    </OnboardingLayout>
  );
}

export const Route = createFileRoute("/onboarding/create-org")({
  validateSearch: createOrgSearchSchema,
  component: CreateOrgPage,
  staticData: { authorize: true, requiresAccount: false },
});
